import React from "react";

const SvgComponent = props => (
  <svg
    version={1.0}
    viewBox="0 0 2048 2048"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M614 153.5V307h103V205h921v102h103V0h-103v102H717V0H614v153.5zM205 461v51h102v1331H205v103h307v-103H410V512h102V410H205v51zM860.5 1171.7c-139 365.1-253 664.6-253.3 665.5-.4 1.7 3.1 1.8 68.5 1.8h69l71.4-204.5 71.4-204.5h570l73.4 204.5 73.5 204.5h68.9c66.1 0 68.9-.1 68.5-1.8-.3-1-113.6-300.5-251.8-665.5L1238.7 508H1113.4l-252.9 663.7zm431.9-173.4c66 179.9 120.1 327.8 120.4 328.4.3 1-48.2 1.3-240.3 1.3-192.1 0-240.6-.3-240.3-1.3.3-.6 53.7-148.5 118.9-328.4C1137 760.7 1169.9 671 1171 671c1.1 0 34.6 90.3 121.4 327.3z" />
  </svg>
);

export default SvgComponent;
